export enum DownloadTypeEnum {
  FULL = 'Full',
  REGULAR = 'Regular',
}
